// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ActiveWhen {
  NonZero = 0,
  Zero = 1,
  InValues = 2,
  Always = 3,
}
